"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RawAccordion = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames5 = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

/** A stateless accordion component */
var RawAccordion = function RawAccordion(_ref) {
  var _classnames3;

  var type = _ref.type,
      label = _ref.label,
      sublabel = _ref.sublabel,
      headerElement = _ref.headerElement,
      children = _ref.children,
      name = _ref.name,
      classNames = _ref.classNames,
      id = _ref.id,
      onClick = _ref.onClick,
      expanded = _ref.expanded;

  var _ref2 = classNames || {},
      wrapper = _ref2.wrapper,
      header = _ref2.header,
      content = _ref2.content,
      expandedClassName = _ref2.expanded,
      labelClassName = _ref2.label,
      sublabelClassName = _ref2.sublabel;

  var headerID = "".concat(id, "-header");
  var contentID = "".concat(id, "-content");
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames5.default)(_indexModule.default.Accordion, wrapper)
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _classnames5.default)(_indexModule.default.header, header, (0, _defineProperty2.default)({}, _indexModule.default.headerSmall, type === 'small')),
    type: "button",
    "aria-expanded": expanded,
    "aria-controls": contentID,
    id: headerID,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.labelWrapper
  }, (label || headerElement) && /*#__PURE__*/_react.default.createElement("div", {
    className: labelClassName
  }, label || headerElement), sublabel && /*#__PURE__*/_react.default.createElement("p", {
    className: (0, _classnames5.default)(_indexModule.default.sublabel, sublabelClassName)
  }, sublabel)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames5.default)(_indexModule.default.headerIcon, (0, _defineProperty2.default)({}, _indexModule.default.expanded, expanded))
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    size: type === 'small' ? 'small' : 'medium',
    type: "chevron-down",
    "aria-label": "".concat(expanded ? 'Collapse' : 'Show', " ").concat(name || id)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames5.default)((_classnames3 = {}, (0, _defineProperty2.default)(_classnames3, _indexModule.default.expanded, expanded), (0, _defineProperty2.default)(_classnames3, _indexModule.default.collapsed, !expanded), (0, _defineProperty2.default)(_classnames3, expandedClassName || '', expanded), _classnames3)),
    "aria-labelledby": headerID,
    "aria-hidden": !expanded,
    id: contentID,
    role: "region"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames5.default)(_indexModule.default.contentWrapper, content, (0, _defineProperty2.default)({}, _indexModule.default.contentWrapperSmall, type === 'small'))
  }, children)));
};

exports.RawAccordion = RawAccordion;
RawAccordion.propTypes = {
  expanded: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func
};